module.exports = __webpack_public_path__ + "static/media/16UNODC22.ffc7cb0e.jpg";